<template>
  <div class="-social">
    <div class="-thumbnail-wrapper">
      <div class="-thumbnail" @click="previewAsset">
        <wt-asset-overlay
          :show-play-icon="isVideo && !selected"
          :dateFull="publicationDateFull"
        >
          <span
            slot="append-right"
            class="-duration"
            v-if="isVideo && (selected || showDuration)"
          >
            <span v-if="selected">▶︎</span>
            <span v-else-if="!!duration && isInFavoritesTab">{{
              duration
            }}</span>
          </span>
        </wt-asset-overlay>
        <a href="#">
          <img :src="mixinProxySrc(src)" />
        </a>
        <slot name="checkmark"></slot>
      </div>
      <footer class="-social">
        <div class="-asset-details">
          <div class="-date" :title="publicationDateFull">
            {{ publicationDate }}
          </div>
          <div class="-activity">
            <span v-if="likesCount" :title="likesTitle">
              <span class="wticon wticon-heart"></span>
              <span>{{ likesCount }}</span>
            </span>
          </div>
        </div>
        <div class="-user-details">
          <img
            class="wt-asset-social-profile-image"
            :src="mixinProxySrc(asset.metadata.socialUserProfileImageUrl)"
          />
          <!--<span class="-social-name">{{asset.metadata.socialUserName}}</span>-->
          <span class="-social-screen-name"
            >@{{ asset.metadata.socialUserScreenName }}</span
          >
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import AssetMixins from 'components/assets/mixins/AssetMixins.vue';
import AssetOverlay from 'components/assets/mixins/AssetOverlay.vue';
import Vue from 'vue';
import app from 'app';

export default Vue.extend({
  mixins: [AssetMixins],
  components: { 'wt-asset-overlay': AssetOverlay },

  props: {
    searchContextId: {
      type: String,
      required: true,
    },
  },

  computed: {
    isInFavoritesTab() {
      return this.searchContextId === app.PROVIDERS.FAVORITES.id;
    },

    type() {
      const type = this.asset.metadata.instagramAssetMetadata.instagramPostType;
      return type || 'text';
    },

    isVideo() {
      return this.type === 'video';
    },

    isImage() {
      return this.type === 'photo';
    },

    src() {
      if (this.isVideo) {
        return this.asset.metadata.posterUrl;
      }
      if (this.isImage) {
        return this.asset.metadata.providerLowResAssetUrl;
      }
      return '';
    },

    likesTitle() {
      if (
        this.asset.metadata.instagramAssetMetadata &&
        this.asset.metadata.instagramAssetMetadata.socialLikesCount
      ) {
        return (
          this.asset.metadata.instagramAssetMetadata.socialLikesCount.toLocaleString() +
          ' Likes'
        );
      }
      return false;
    },

    likesCount() {
      if (
        !this.asset.metadata.instagramAssetMetadata ||
        !this.asset.metadata.instagramAssetMetadata.socialLikesCount
      ) {
        return 0;
      }
      return this.asset.metadata.instagramAssetMetadata.socialLikesCount.toFriendlyNumber(
        1
      );
    },

    showDuration() {
      return !!this.duration;
    },

    duration() {
      if (!this.asset.metadata.duration) {
        return '';
      }
      return app.moment.utc(this.asset.metadata.duration * 1000).format('m:ss');
    },
  },
});
</script>
